module.exports = __webpack_public_path__ + "img/img2_1.f3c13933.jpeg";